// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__bIS0C","checkboxCol":"Table_checkboxCol__2hloe","emailCol":"Table_emailCol__1UBjb","actionCol":"Table_actionCol__1B1aj"};